import React, { PureComponent } from 'react'

class Crosshair extends PureComponent {
  render () {
    return (
      <svg
        x={this.props.x - this.props.size / 2}
        y={this.props.y - this.props.size / 2}
        viewBox='-10 -10 415 415' width={this.props.size} height={this.props.size}
      >
        <g {...this.props}>
          <circle cx='202.224' cy='202.228' r='26.686' />
          <path d='M83.807,49.322L50.87,4.891c-9.519-9.527-30.71-3.78-40.236,5.747S-4.64,41.347,4.887,50.874
            l44.431,32.937c9.519,9.519,24.963,9.527,34.49,0C93.334,74.284,93.326,58.84,83.807,49.322z'
          />
          <path d='M393.823,10.638c-9.527-9.527-30.71-15.274-40.236-5.747l-32.937,44.431
            c-9.527,9.527-9.527,24.963,0,34.49c9.527,9.527,24.963,9.519,34.49,0l44.431-32.937
            C409.096,41.347,403.349,20.164,393.823,10.638z'
          />
          <path d='M355.139,320.645c-9.527-9.527-24.963-9.527-34.49,0c-9.527,9.527-9.527,24.963,0,34.49
            l32.937,44.431c9.527,9.519,30.71,3.78,40.236-5.747s15.274-30.71,5.747-40.236L355.139,320.645z'
          />
          <path d='M49.318,320.645L4.887,353.582c-9.527,9.527-3.78,30.71,5.747,40.236s30.71,15.274,40.236,5.747
            l32.937-44.431c9.527-9.519,9.527-24.963,0-34.49C74.28,311.127,58.844,311.127,49.318,320.645z'
          />
        </g>
      </svg>
    )
  }
}

export default Crosshair
